export enum Locale {
  RU = 'ru',
  EN ='en',
}
